/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { call, put, select, takeEvery } from "redux-saga/effects";

import { format, getIsUserSignedIn } from "@gamedev-web/gamedev-sdk-core";

import { siteLocationPrefix } from "../../constants";
import { OnboardingErrorType } from "../../models/errors";
import { CountryValidationsData } from "../../server/crm/api/models/countryValidations";
import { countryCrmCodeToIso } from "../../server/crm/api/utils/countryCrmCodeToIso";
import { PartnerCenterActions, partnerCenterActions } from "../actions/partnerCenterActions";
import { OnboardingRootState } from "../reducers/rootReducer";
import { getCountryValidationsByCode } from "../selectors/partnerCenterSelectors";
import { storeError } from "./dataStorage/storeError";

const countryValidationDataUrl = `${siteLocationPrefix}/partnercenter/countryValidations?country={0}`;
const initEnrollmentUrl = `${siteLocationPrefix}/partnercenter/initEnrollment?fileName={0}&dunsValue={1}&typeFile={2}`;

export function* fetchCountryValidation(
  action: ReturnType<typeof partnerCenterActions.fetchCountryValidation.start>
) {
  const isSigned: boolean | undefined = yield select(getIsUserSignedIn);
  if (!isSigned) {
    return;
  }

  try {
    const codeToCountryMap = countryCrmCodeToIso[action.country];
    const urlWithCountryCode = format(countryValidationDataUrl, codeToCountryMap);
    const existsCountry: boolean | undefined = yield select((state: OnboardingRootState) =>
      getCountryValidationsByCode(state, action.country)
    );
    if (existsCountry) {
      return;
    }
    const response: Response = yield call(fetch, urlWithCountryCode);
    const data: CountryValidationsData = yield call([response, "json"]);
    if (data) {
      yield put(partnerCenterActions.fetchCountryValidation.success(data, action.country));
    } else {
      yield storeError(
        "Country validation data not found",
        OnboardingErrorType.CountryValidationFetch
      );
    }
  } catch (e) {
    yield storeError(e, OnboardingErrorType.CountryValidationFetch);
  }
}

export function* fetchFileUpload(
  action: ReturnType<typeof partnerCenterActions.fetchFileUpload.start>
) {
  const isSigned: boolean | undefined = yield select(getIsUserSignedIn);
  if (!isSigned) {
    return;
  }
  const chunk = action.chunk;
  const fileName = action.fileName;
  const dunsValue = action.dunsValue;
  const typeFile = action.typeFile;
  try {
    const urlWithFile = format(initEnrollmentUrl, fileName, dunsValue, typeFile);

    const response: Response = yield call(fetch, urlWithFile, {
      method: "POST",
      body: chunk,
      headers: {
        "Content-Type": "application/octet-stream",
        Accept: "application/octet-stream",
      },
    });

    if (response.status === 200) {
      yield put(partnerCenterActions.fetchFileUpload.success());
    } else {
      yield storeError(
        `File upload failed with response status ${response.status}`,
        OnboardingErrorType.PartnerCenterFileUpload
      );
    }
  } catch (e) {
    yield storeError(e, OnboardingErrorType.PartnerCenterFileUpload);
  }
}

export function* partnerCenterSagas() {
  yield takeEvery(PartnerCenterActions.FETCH_COUNTRY_VALIDATION_START, fetchCountryValidation);
  yield takeEvery(PartnerCenterActions.FETCH_FILE_UPLOAD_START, fetchFileUpload);
}
